<template>
    <div class="EstimationsDataEntry">
        <!-- Toy -->
        <Mikomi_SP v-if="TeamFilter.includes('フィギュア')" :MikomiTypeData="ToyData" :CellTitlePrefix="MonthLabel + ' ' + CellTitlePrefix + '（フィギュア）'" :CellColor="CellColor" />
        <!-- Plastic -->
        <Mikomi_SP v-if="TeamFilter.includes('プラモ')" :MikomiTypeData="PlasticData" :CellTitlePrefix="MonthLabel + ' ' + CellTitlePrefix + '（プラモ）'" :CellColor="CellColor" />
        <!-- Digital -->
        <Mikomi_SP v-if="TeamFilter.includes('デジタル')" :MikomiTypeData="DigitalData" :CellTitlePrefix="MonthLabel + ' ' + CellTitlePrefix + '（デジタル414）'" :CellColor="CellColor" />
        <!-- XPNA -->
         <Mikomi_SP v-if="TeamFilter.includes('XPNA')" :MikomiTypeData="XPNAData" :CellTitlePrefix="MonthLabel + ' ' + CellTitlePrefix + '（XPNA）'" :CellColor="CellColor" />
        <!-- TTL -->
        <Mikomi_SP :MikomiTypeData="TTLData" :CellTitlePrefix="MonthLabel + ' ' + CellTitlePrefix + '（TTL）'" :CellColor="CellColor" />
        <!-- Others -->
        <Mikomi_Others :MikomiTypeData="OtherData" :CellTitlePrefix="MonthLabel + ' ' + CellTitlePrefix + ''" :CellColor="CellColor" />
    </div>
</template>

<script>
import Mikomi_SP from './Mikomi_SP.vue';
import Mikomi_Others from './Mikomi_Others.vue';
export default{
    components:{
        Mikomi_SP,
        Mikomi_Others,
    },
    computed:{
        ToyData()
        {
            // console.log('return toy data', this.MikomiTypeData);
            return {
                sales: this.MikomiTypeData.sales_figures,
                provProfit: this.MikomiTypeData.provProfit_figures,
            };
        },
        PlasticData()
        {
            return {
                sales: this.MikomiTypeData.sales_plastic,
                provProfit: this.MikomiTypeData.provProfit_plastic,
            };
        },
        DigitalData()
        {
            return {
                sales: this.MikomiTypeData.sales_digital,
                provProfit: this.MikomiTypeData.provProfit_digital,
            };
        },
        XPNAData()
        {
            return {
                sales: this.MikomiTypeData.sales_xpna,
                provProfit: this.MikomiTypeData.provProfit_xpna,
            }
        },
        TTLData()
        {
            return {
                sales: this.MikomiTypeData.sales_figures + this.MikomiTypeData.sales_plastic + this.MikomiTypeData.sales_digital + this.MikomiTypeData.sales_xpna,
                provProfit: this.MikomiTypeData.provProfit_figures + this.MikomiTypeData.provProfit_plastic + this.MikomiTypeData.provProfit_digital + this.MikomiTypeData.provProfit_xpna,
            };
        },
        OtherData()
        {
            return {
                sales: this.MikomiTypeData.sales_figures + this.MikomiTypeData.sales_plastic + this.MikomiTypeData.sales_digital + this.MikomiTypeData.sales_xpna,
                // In case of result data, the 総益 is named grossOperatingProfit
                profit: this.IsEstimation ? null : this.IsResult || this.IsDifference ? this.MikomiTypeData.grossOperatingProfit !== undefined ? this.MikomiTypeData.grossOperatingProfit : this.MikomiTypeData.profit : this.MikomiTypeData.profit,
                operatingProfit: this.IsEstimation ? null : this.MikomiTypeData.operatingProfit,
                netIncome: this.IsEstimation ? null : this.MikomiTypeData.netIncome,
                stock: this.MikomiTypeData.stock
            };
        },
    },
    props:{
        MikomiTypeData: Object,
        MonthLabel: String,
        CellTitlePrefix: String,
        CellColor: String,
        IsEstimation: Boolean,
        IsResult: Boolean,
        IsDifference: Boolean,
        TeamFilter: Array,
    },
    // created(){
    //     if (this.MonthLabel === 'Q1')
    //     {
    //         console.log(`[Mikomi_Type] ${this.MonthLabel} ${this.CellTitlePrefix??''}`, this.MikomiTypeData);
    //     }
    // }
}
</script>